// src/components/admin/dashboard/StockAlerts.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import type { FirebaseProduct } from '../../../types/product';
import { formatPrice } from '../../../utils/helpers';

interface StockAlertsProps {
  products: FirebaseProduct[];
}

const StockAlerts: React.FC<StockAlertsProps> = ({ products }) => {
  if (products.length === 0) {
    return (
      <div className="bg-white p-6 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Stock Status</h3>
        </div>
        <div className="text-center py-8 text-gray-500">
          <AlertTriangle className="w-12 h-12 mx-auto mb-3 text-gray-400" />
          <p>All products are well stocked</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">Low Stock Alerts</h3>
        <Link 
          to="/admin/products" 
          className="text-brand-blue-500 text-sm hover:underline"
        >
          View All Products
        </Link>
      </div>
      <div className="space-y-3">
        {products.map((product) => (
          <div 
            key={product.id} 
            className="flex items-center justify-between p-4 bg-red-50 rounded-lg"
          >
            <div className="flex items-center space-x-3">
              <AlertTriangle className="h-5 w-5 text-red-500" />
              <div>
                <p className="font-medium">{product.name}</p>
                <p className="text-sm text-red-600">
                  {product.stock === 0 ? 'Out of stock' : `${product.stock} units remaining`}
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-sm font-medium">
                {formatPrice(product.price || 0)}
              </span>
              <Link 
                to={`/admin/products/${product.id}/edit`}
                className="px-3 py-1 text-sm bg-white rounded-lg hover:bg-gray-50"
              >
                Update
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StockAlerts;